import { useState, useEffect, useRef, useCallback } from 'react';
import styles from './BluetoothConfigEditor.module.scss';

function BluetoothConfigEditor({ configData, onConfigChange, isEditingJson }) {
  const [name, setName] = useState('');
  const [enabled, setEnabled] = useState(false);

  const lastConfigDataRef = useRef('');
  const isUpdatingFromGuiRef = useRef(false);

  // Generate JSON from GUI settings
  const generateConfig = useCallback(() => {
    const config = {
      name,
      enabled,
    };

    return JSON.stringify(config, null, 2);
  }, [name, enabled]);

  // Parse JSON to GUI when configData changes from external source
  useEffect(() => {
    if (
      configData &&
      configData !== lastConfigDataRef.current &&
      !isUpdatingFromGuiRef.current &&
      !isEditingJson
    ) {
      lastConfigDataRef.current = configData;

      try {
        const config = JSON.parse(configData);

        setName(config.name !== undefined ? String(config.name) : '');
        setEnabled(config.enabled !== undefined ? config.enabled : false);
      } catch (error) {
        console.error('Error parsing bluetooth config:', error);
      }
    }
  }, [configData, isEditingJson]);

  // Update parent component when GUI settings change
  useEffect(() => {
    // Skip the first render and when we're parsing from external config
    if (lastConfigDataRef.current) {
      isUpdatingFromGuiRef.current = true;
      const newConfig = generateConfig();
      lastConfigDataRef.current = newConfig;
      onConfigChange(newConfig);

      // Reset the flag after a short delay to allow the parent to update
      setTimeout(() => {
        isUpdatingFromGuiRef.current = false;
      }, 10);
    }
  }, [name, enabled, generateConfig, onConfigChange]);

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Bluetooth Settings</h3>

      <div className={styles.setting}>
        <label className={styles.label}>
          <input type="checkbox" checked={enabled} onChange={e => setEnabled(e.target.checked)} />
          Bluetooth Enabled
        </label>
      </div>

      <div className={styles.setting}>
        <label className={styles.field}>
          <span className={styles.inputLabel}>Device Name</span>
          <input
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
            className={styles.input}
            placeholder="TernaHub-xxxxxxxxxxxx"
            maxLength={32}
          />
        </label>
      </div>
    </div>
  );
}

export default BluetoothConfigEditor;
